export const baseUrl =
  process.env.REACT_APP_IS_PRODUCTION === "true"
    ? "https://afsha-good-deeds-app.onrender.com"
    : "http://localhost:5000";
